"use client";

import { Check } from "lucide-react";
import { colorOptions } from "@/lib/colors";
import { cn } from "@/lib/utils";

interface ColorPickerProps {
  value: string;
  onChange: (id: string) => void;
}

export function ColorPicker({ value, onChange }: ColorPickerProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {colorOptions.map((color) => {
        const selected = color.id === value;
        return (
          <button
            key={color.id}
            type="button"
            title={color.label}
            aria-label={color.label}
            aria-pressed={selected}
            onClick={() => onChange(color.id)}
            className={cn(
              "relative flex size-9 items-center justify-center rounded-full ring-offset-2 ring-offset-background transition-all",
              selected ? "ring-2 ring-primary" : "hover:ring-2 hover:ring-muted-foreground/40",
              color.needsBorder && "border border-border"
            )}
            style={{ backgroundColor: color.hex }}
          >
            {selected && (
              <Check
                className="size-4"
                strokeWidth={3}
                style={{
                  color: color.id === "weiss" || color.id === "gelb" ? "#111" : "#fff",
                }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
